import { useState, useEffect, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI/index.js";
import { useAuth } from "../../utility/auth.js";
import ImagePreview from "../../components/FormsUI/PreviewImage/index";
import UserMedicalCenterMappingController from "../../controller/UserMedicalCenterMappingController.jsx";
import UserController from "../../controller/UserController.jsx";
import DepartmentController from "../../controller/DepartmentController.jsx";
import SubDepartmentController from "../../controller/SubDepartmentController.jsx";
import CustomizedSnackbars from "../../components/Alert/index.js";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme.js";
import {
    Container,
    Grid,
    useTheme,
    Box,
    Stack,
    IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController.jsx";
import MedicalCenterController from "../../controller/MedicalCenterController.jsx";


const INITIAL_FORM_STATE = {
    wef: "",
    medicalCentreId: "",
    userId: "",
};
const FORM_VALIDATION = Yup.object().shape({
    wef: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "WEF is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(3, "Minimum 3 characters required")
        .max(100, "WEF should not exceed 100 characters")
        .optional(),

    // .required("Sub Department Name is required"),
    medicalCentreId: Yup.string()
        .matches(/^[0-9a-fA-F]{24}$/, "Invalid MedicalId DepartmentId format") // ✅ Only for ObjectId
        .required("Department name is required"),
    userId: Yup.string()
        .matches(/^[0-9a-fA-F]{24}$/, " Invalid UserId subDepartmentId format") // ✅ Only for ObjectId
        .required("sub-department name is required"),
    // serviceRemark: Yup.string()
    //     .matches(/^[A-Za-z0-9 ]*$/, "Service Remark  is not in correct format")
    //     .trim("No white space allowed")
    //     .strict(true)
    //     .min(2, "Minimum 2 characters required")
    //     .max(200, "Service Remark should not exceed 20 characters")
    //     .optional(),
    // subDepartmentImage: Yup.mixed().optional(),

});


let requestType = "";
const UserMedicalCentreMapping = () => {
    const userController = new UserController();
    const medicalCenterController = new MedicalCenterController();
    const medicalCenterMappingController = new UserMedicalCenterMappingController();

    const exceptionHandlerController = new ExceptionHandlerController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [userOptions, setUserOptions] = useState();
    const [medicalOptions, setMedicalOptions] = useState();
    const [userMedicalCentreMapping, setUserMedicalCentreMapping] = useState([])

    const [loader, setLoader] = useState(true);
    const [departmentId, setDepartmentId] = useState('');
    const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [popup, setPopUp] = useState(false);
    const [allUsers, setAllUsers] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    useEffect(() => {
        getAllUserMedicalMapping();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getAllUser = async () => {
        debugger
        let caughtError;
        try {
            const response = await userController.getAllUsers(token, tenantId);
            if (response.status === 200) {
                const userData = response?.data?.body?.map((item) => ({
                    // ...item,
                    userName: item.userName,
                    userId: item.userId,
                }));
                setUserOptions(userData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllUser in UserMedicalMapping page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getMedicalCentre = async (departmentId) => {
        debugger
        let caughtError;
        try {
            const response = await medicalCenterController.GetAllMedicalCenter(token);
            if (response.status === 200) {
                const mediaclCenterData = response?.data?.body?.map((item) => ({
                    // ...item,
                    medicalCentreName: item.centerLongName,
                    medicalCentreId: item._id,
                }));
                setMedicalOptions(mediaclCenterData);
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getSubDepartment in UserMedicalMapping Page",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllUserMedicalMapping = async () => {
        debugger
        let caughtError;
        try {
            const response = await medicalCenterMappingController.GetAllMedicalCentreMapping(token);
            if (response.status === 200) {
                const serviceData = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setUserMedicalCentreMapping(serviceData ?? '');
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllUserMedicalMapping",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const columns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "User Name", field: "userName", width: 250 },
        { headerName: "Medical Centre Name", field: "centerLongName", width: 300 },
        { headerName: "WEF", field: "wef", width: 210 },
        {
            field: "action",
            headerName: "Action",
            width: 210,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            requestType = "Edit";
                            setUpdatedValues(() => currentRow);
                            const currentRowData = currentRow;
                            setUpdatedValues(() => currentRowData);
                            // setSubDepartmentImage(currentRow.subDepartmentImage)
                            setUserOptions([{
                                userName: currentRow.userName,
                                userId: currentRow.userId
                            }])
                            setMedicalOptions([{
                                medicalCentreName: currentRow.medicalCentreName,
                                medicalCentreId: currentRow.medicalCentreId
                            }])
                            getAllUser()
                            getMedicalCentre();
                            handleData();
                        } else {
                            medicalCenterController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllUserMedicalMapping()
                                        showAlert("success", "Deleted successfully");
                                        setAllUsers((i) => {
                                            return allUsers.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "Department onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const AddDepartment = async () => {
        requestType = "Add";
        getAllUser();
        getMedicalCentre();
        setUpdatedValues(() => INITIAL_FORM_STATE);
        // setSubDepartmentImage(null)
        handleData();
    };


    const submitValues = (submitValueData) => {
        debugger
        let submitData = {};
        // tenantId coming from parent/component
        submitData.tenantId = tenantId;

        // submitData.append("tenantId", tenantId);
        // Map form fields
        submitData.wef = submitValueData?.wef?.trim() ?? "";
        submitData.userId = submitValueData?.userId?.trim() ?? "";
        submitData.medicalCentreId = submitValueData?.medicalCentreId?.trim() ?? "";

        //add for image
        if (requestType === "Edit") {
            submitData.id = submitValueData?.id?.trim() ?? "";

            const Id = submitValueData?.id;
            // assuming ID comes from backend
            medicalCenterMappingController
                .Update(Id, submitData, token)
                .then((response) => {
                    if (response.status === 200) {
                        getAllUserMedicalMapping();
                        showAlert("success", response?.data?.message);
                        handlePopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        // getAllCenters();
                    } else {
                        if (response?.data?.status === 204)
                            showAlert("error", response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            medicalCenterMappingController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllUserMedicalMapping();
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 409) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };


    const handlePopup = (value) => setPopUp(() => value);
    const handleData = () => setPopUp(() => true);
    if (loader) return <Load />;
    return (
        <>
            <Box
                sx={{
                    "& .formBg": {
                        border: `1px solid ${colors.grey[900]}`,
                        background: `${colors.primary[400]}`,
                    },
                    "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                    "& .MuiGrid-root.Mui-heading h2": {
                        color: `${colors.primary[200]} !important`,
                    },
                }}
            >
                <Grid container>
                    <Grid className="breadcrumb-section">
                        <Grid className="breadcrumb-container">
                            <Grid className="Mui-li">
                                <nav className="Mui-nav" aria-label="breadcrumb">
                                    <ol className="">
                                        <li className="MuiBreadcrumbs-li">
                                            <h6 className="breadsub">Medical</h6>
                                        </li>
                                        <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                            /
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <h6>User Medical Centre Mapping</h6>
                                        </li>
                                    </ol>
                                </nav>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} className="adduser">
                        <Controls.ActionButton onClick={() => AddDepartment()}>
                            <span>Add New</span>
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item xs={12} className="formBg">
                        <Container maxWidth="md" className="formClwidth">
                            <div>
                                <Controls.Grid
                                    columns={columns}
                                    data={userMedicalCentreMapping}
                                    fileName={"Users"}
                                />
                                {popup && (
                                    <Controls.Popup
                                        title="User Medical Center Mapping "
                                        openPopup={popup}
                                        setOpenPopup={handlePopup}
                                    >
                                        <Formik
                                            enableReinitialize
                                            initialValues={{
                                                ...(updatedValues || INITIAL_FORM_STATE),
                                            }}
                                            validationSchema={FORM_VALIDATION}
                                            onSubmit={(values) => submitValues(values)}
                                        >
                                            {({ values, setFieldValue }) => (
                                                <Form>
                                                    <Grid container spacing={2}>


                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="userId"
                                                                value={
                                                                    userOptions?.find(
                                                                        (opt) => opt.userId === values.userId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select User <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={userOptions || []}
                                                                getOptionLabel={(option) => option?.userName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.userId === value?.userId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("userName", value ? value.userName : ""); // ✅ only save string
                                                                    setFieldValue("userId", value ? value.userId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="medicalCentreId"
                                                                value={
                                                                    medicalOptions?.find(
                                                                        (opt) => opt.medicalCentreId === values.medicalCentreId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select medical centre <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={medicalOptions || []}
                                                                getOptionLabel={(option) => option?.medicalCentreName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.medicalCentreId === value?.medicalCentreId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("medicalCentreName", value ? value.medicalCentreName : ""); // ✅ only save string
                                                                    setFieldValue("medicalCentreId", value ? value.medicalCentreId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>


                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="wef"
                                                                label="WEF"
                                                                type="string"
                                                                inputProps={{ maxLength: 100 }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={4} md={2} className="marginAuto">
                                                        <Controls.Button>Submit</Controls.Button>
                                                    </Grid>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Controls.Popup>
                                )}
                            </div>
                        </Container>
                    </Grid>
                    {alert?.counter > 0 && (
                        <CustomizedSnackbars
                            status={alert?.counter}
                            msg={alert?.msg}
                            type={alert?.type}
                        />
                    )}
                </Grid>
            </Box>
        </>
    );
};

export default UserMedicalCentreMapping;
